/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../Store/action";
import { MEMBERSHIP_ACTION_TYPE } from "../Store/membership/Type";
import Announcement from "../pages/dashboard/components/Announcement";
import IntegrationDisconnectBanner from "../pages/dashboard/components/IntegrationDisconnectBanner";
import UpgradeToV2Banner from "../pages/dashboard/components/UpgradeToV2Banner";
import { BASEURL, convertTimeIntoSselectedTZ } from "../utilites";
import Modal from "../components/Dashboard/Modal";
import Navbar from "../pages/dashboard/components/Navbar";
import ToastMessage from "../components/ToastMessage";
import moment from "moment-timezone";
import { MdDone } from "react-icons/md";
import { RiMessage2Line } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import CustomerMessageBoardModal from "../pages/dashboard/leads/components/CustomerMessageBoardModal";
import { useLocation } from 'react-router-dom';
import MultyStepOnboading from "../components/forms/MultyStepOnboarding/MultyStepOnboading";
import questionsData from "../utilites/questionnaireData.json";





export default function DashboardLayout() {
	// --------------------------------------------
	// React States , Variable , Build in Redux
	// --------------------------------------------
	const dispatch = useDispatch();
	const navigate = useNavigate();
  const location = useLocation();
	const [showToast,setShowToast] = useState(false)
	const [customerModal,setCustomerModal] = useState()
	const [showCustomerMessageBoard,setShowCustomerMessageBoard] = useState(false)
	const [showAppointmentsToast,setShowAppointmentsToast] = useState(true)
	const [user, {customerModalDone, profile, pastAppointments}] = useSelector((state) => [state.user, state.dashboard]);
	// const { assessmentLoading } = useSelector(state => state.user);
	const [{personalConnections}] = useSelector((state) => [state.firebase]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [isTab, setIsTab] = useState(window.innerWidth < 940);
  const [showMessageBoardButton,setShowMessageboardButton] = useState(false)
  const [enableCloseWelcomeModal,setEnableCloseWelcomeModal] = useState(false)
  const isDashboard = location.pathname === "/dashboard" || location.pathname === "/dashboard/";


	  const [loading, setLoading] = useState({
    state: false,
    answer: null,
    success: null,
  });
	const conditionCheckForPasswordModal =
		user?.LoginData?.isCustomer &&
		!user?.LoginData?.isAdmin &&
		!user?.LoginData?.settings?.firstTimeCustomerUpdatePassword &&
		!user?.LoginData?.impersonation &&
		!customerModalDone && !customerModal
	const conditionCheckForLoginReminder =
		(user?.LoginData?.isCustomer) &&
		!user?.LoginData?.settings?.firstTimeCustomerLoginReminder 
    const IsWelcomeModal =
		(user?.LoginData?.isCustomer) &&
		!user?.LoginData?.settings?.IsWelcomeModal &&
    isDashboard &&
    user?.LoginData?.lead[0]?.userpro?.uuid && 
    !user?.LoginData?.settings?.welcomeCoupon &&
    user?.LoginData?.settings?.newUser


  let assessmentContent = user?.LoginData?.assessment?.content;

  const questionnaireState = {
    min: 0,
    max: questionsData.length,
    value:
      user?.LoginData?.assessment !== null && assessmentContent
        ? Object?.keys(assessmentContent).length
        : 0,
  };

	// --------------------------------------------
	// HOOKS TO HANDLE RESPONSES OF API's
	// --------------------------------------------
	useEffect(() => {
		if (localStorage.getItem("token") && user.loginStatus === false && user.error === "") {
			dispatch(allActions.user.ReGetUserData());
		}
		if (user.error === "Invalid Token") {
			dispatch(allActions.user.logout());
			dispatch(allActions.dashboard.reset());
			dispatch(allActions.firebase.reset());
		}
	}, [user, dispatch]);

	useEffect(() => {
		if (profile?.state === true  && user?.LoginData?.settings?.firstTimeCustomerLoginReminder && conditionCheckForLoginReminder ) {
			setShowToast(false)
		}
	}, [profile.state, conditionCheckForPasswordModal, conditionCheckForLoginReminder]);
	

  	useEffect(() => {
      if (!IsWelcomeModal) return;
    const loginData = user?.LoginData;
    const lead = loginData?.lead?.[0];
    const userSettings = lead?.userpro?.user?.settings;
    const allowAppointments = userSettings?.allow_appointments;
    const isVerified = loginData?.isVerify;
    const isPasswordChanged = loginData?.settings?.isPasswordChanged;
    const isMessageSent = loginData?.settings?.firstMessageSent;
    const appointment_scheduled = loginData?.settings?.appointment_scheduled;
    const completedQuestionnaire = questionnaireState.value === questionnaireState.max;
    const isVideoWatched = loginData?.settings?.isOnboardingVideoSeen;
    const license = lead?.driver_license;
    
    const setStepAndShowModal = (step) => {
    document.getElementById("showOnboardingVideo").click();
    localStorage.setItem('onboarding_step', step);
    setCustomerModal(true);
    };

    if (
    !isVideoWatched &&
    !isPasswordChanged &&
    !isVerified &&
    !license &&
    !isMessageSent
    ) {
    setStepAndShowModal(0);
    return;
    }

    if (!isVideoWatched) {
    setStepAndShowModal(1);
    return;
    }
    if (!isPasswordChanged) {
    setStepAndShowModal(2);
    return;
    }
    if (!isVerified) {
    setStepAndShowModal(3);
    return;
    }
    if (!appointment_scheduled && allowAppointments) {
    setStepAndShowModal(4);
    navigate(
      `?lead=${lead.uuid}&customer=${user?.LoginData?.uuid}&operator=${lead?.userpro?.uuid}`,
      { replace: true }
    );
    return;
    }
    if (!license) {
    setStepAndShowModal(5);
    return;
    }
    if (!completedQuestionnaire) {
    setStepAndShowModal(6);
    return;
    }
    if (!isMessageSent) {
    setStepAndShowModal(7);
    return;
    }
    setStepAndShowModal(0);

    dispatch(allActions.global.Loader(false));
	}, [IsWelcomeModal]);

	useEffect(() => {
		if (conditionCheckForLoginReminder) {
			dispatch(allActions.global.Loader(false));
			if(user?.LoginData?.isVerify){
				if(user?.LoginData?.isCustomer && user?.LoginData?.settings?.firstTimeCustomerUpdatePassword){
				setShowToast(true)
				}
			}else if(!user?.LoginData?.isVerify){
				if(user?.LoginData?.isCustomer){
				setShowToast(true)
				}
			}
		}
	},[conditionCheckForLoginReminder])


  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
      setIsTab(window.innerWidth < 940)
    };

    window.addEventListener("resize", handleResize);
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  
  useEffect(() => {
    if((location?.pathname === '/dashboard' || location?.pathname === '/dashboard/') && (user?.LoginData?.isCustomer && isDesktop)){
      setShowMessageboardButton(false)
      setShowCustomerMessageBoard(false)
     }else if(location?.pathname.includes('dashboard/messages') && !user?.LoginData?.isCustomer){
      setShowMessageboardButton(false)
      setShowCustomerMessageBoard(false)
     }
     else if(location?.pathname?.includes('/dashboard/contract')  && !isDesktop ){
      setShowMessageboardButton(false)
      setShowCustomerMessageBoard(false)
     }  else {
      setShowMessageboardButton(true)
     }
  },[location, isDesktop])



	const updateHasAttandedStatus = async (has_attended, appointment_id) => {
		setLoading({ state: true, answer: has_attended });
		try {
		  await axios.patch(
			`${BASEURL}/api/appointments/update-has-attended`,
			{
			  has_attended,
			  appointment_id,
			}
		  );
		  setTimeout(() => {
			setLoading({ state: false, answer: has_attended, success: true });
			setTimeout(() => {
			setShowAppointmentsToast(false)
			  dispatch(allActions.dashboard.getPastAppointments());
			  setLoading({
				state: false,
				answer: null,
				success: null,
			  })
			}, 1000);
		  }, 1000);
		} catch (error) {
		  console.log(error);
		  setLoading({ state: false, answer: has_attended, success: false });
		}
	  };
	
	// --------------------------------------------------
	// Local Functions to handle local States , Call Apis
	// --------------------------------------------------
	const stopImpersonation = () => {
		axios
			.delete(`${BASEURL}/api/users/impersonate`)
			.then(() => {
				// Reset Messages Store To Get Data Again
				dispatch(allActions.firebase.resetPersonalConnection());
				dispatch(allActions.firebase.resetReadPersonalChatsArray());
				// Reset global state for dashboard
				dispatch(allActions.dashboard.reset());
				// Reset global state for firebase
				dispatch(allActions.firebase.reset());
				dispatch({ type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlanIdle });
				// Reset global state for user and re-fetch
				dispatch(allActions.user.removeUserData());
				dispatch(allActions.user.ReGetUserData());
				dispatch(allActions.jobs.resetJobs());
				dispatch(allActions.invoice.resetPayInvoice());

			})
			.then(() => navigate("/dashboard/users"))
			.catch((error) => console.error(error));
	};



	const handleSetFirstLoginReminder = () => {
		if(user?.LoginData?.impersonation){
			setShowToast(false)
		}else{
			const profileObj = {
				settings: {
					...user?.LoginData?.settings,
					firstTimeCustomerLoginReminder: true,
				},
			};
			dispatch(allActions.dashboard.updateProfile({ uuid: user?.LoginData?.uuid, profileObj }));
		}
	}

  const handleCloseOnboardingVideo = () => {
		if(user?.LoginData?.impersonation){
			setShowToast(false)
		}else{
			const profileObj = {
				settings: {
					...user?.LoginData?.settings,
					IsWelcomeModal: true,
				},
			};
      if( !user?.LoginData?.settings?.IsWelcomeModal){
        dispatch(allActions.dashboard.updateProfile({ uuid: user?.LoginData?.uuid, profileObj }));
      }
		}
	}

    useEffect(() => {
    if (profile?.state === true) {
      dispatch(allActions.user.ReGetUserData());
    }
  }, [profile.state]);

	const isAllWeekUnavailable = () => {
		let data = user?.LoginData;
		const role = user?.LoginData?.roles[0]?.name;
		let allNull = false;
		if (role === "taxpro") {
		  const objData = data?.availability?.time_ranges;
		if(objData){
			allNull = Object.values(objData).every((value) => value === null);
		}
		} else if (role === "customer") {
		  const objData = data?.lead?.[0]?.userpro?.user.availability?.time_ranges;
		  allNull = Object.values(objData || {}).every((value) => value === null);
		}
		if (allNull) {
		  return true;
		}
		return false;
	  };

		if(!user.loginStatus || !user.LoginData) return

		
	return (
    <div className="dashboard">
      <main className="clearfix w-100">
        <UpgradeToV2Banner />
        {user?.LoginData?.impersonation &&
        user?.LoginData?.impersonation !== null ? (
          <Announcement
            condition={true}
            buttonEnabled={true}
            alertClass="warning d-flex justify-content-between py-2"
            mainClass="clearfix w-100 mx-auto"
            containerClass="container"
            title="User impersonation is Activated!"
            details={`You are currently impersonating ${user?.LoginData?.firstname} ${user?.LoginData?.lastname}. Click the button below to stop impersonating`}
            buttonLink={null}
            buttonText="Stop Impersonation"
            buttonClass="badge bg-dark py-2 text-decoration-none px-3"
            clickHandler={stopImpersonation}
          />
        ) : (
          user?.LoginData?.isTaxPro && <></>
        )}
        <IntegrationDisconnectBanner />
        {user?.LoginData?.isTaxPro && isAllWeekUnavailable() && (
          <Announcement
            condition={true}
            buttonEnabled={false}
            alertClass="primary d-flex justify-content-between text-center py-2"
            mainClass="clearfix w-100 mx-auto"
            containerClass="container"
            title="Tax Professional Schedular"
            details={
              <>
                - Hi {user?.LoginData?.firstname}, Please adjust your available
                appointment times on the{" "}
                {
                  <span
                    onClick={() =>
                      navigate("/dashboard/settings", {
                        state: { openModal: ".userAvailablityForm" },
                      })
                    }
                  >
                    <Link>Settings Page</Link>.
                  </span>
                }
              </>
            }
            buttonLink={null}
            buttonText="Edit Availability"
            buttonClass="badge bg-dark py-2 text-decoration-none px-3"
            clickHandler={stopImpersonation}
          />
        )}
        <Navbar />
          <div className="container dashboard-container">
          <Outlet />
        </div>
        {showCustomerMessageBoard && (
          <CustomerMessageBoardModal
            uuid=""
            group={false}
            isDesktop={isDesktop}
            isTab={isTab}
            setShowCustomerMessageBoard={setShowCustomerMessageBoard}
            showCustomerMessageBoard={showCustomerMessageBoard}
            showMessageBoardButton={showMessageBoardButton}
          />
        )}
        {showMessageBoardButton && (!isDesktop ? !showCustomerMessageBoard : true) && (
          <div className="container position-relative">
            {/* {user?.LoginData?.isCustomer && ( */}
            <div
              className={`${
                isDesktop
                  ? "open-message-board-button-desktop"
                  : "open-message-board-button"
              } cursor-pointer`}
              onClick={() => setShowCustomerMessageBoard((prev) => !prev)}
            >
              {personalConnections?.notification &&
               parseInt(personalConnections?.notification) > 1 ? (
                <span
                  className="badge badge-notification bg-danger position-absolute top-0 rounded-circle end-3 right-0 mx-4"
                  style={{ fontSize: "14px", right: "-15px" }}
                >
                  {personalConnections?.notification - 1}
                </span>
              ) : (
                ""
              )}
              {showCustomerMessageBoard ? (
                <IoMdClose color="white" />
              ) : (
                <RiMessage2Line color="white" />
              )}
            </div>
            {/* )} */}
          </div>
        )}
      </main>
      <ToastMessage
        styles={{ marginTop: 90, minWidth: 400 }}
        onClose={handleSetFirstLoginReminder}
        title={`👋 Hey ${user?.LoginData?.firstname},Welcome to Your Dashboard. Don't miss our live traning with Karla Dennis! ✅`}
        message={
          <>
            Learn tax saving secrets for 2025.Reservation is free!{"\n"}
            👉
            <a
              target="_blank"
              rel="noreferrer"
              href="https://taxmakeoversummit.com/training"
            >
              Click here to join
            </a>
          </>
        }
        show={showToast}
        setShow={setShowToast}
      />
      {user?.LoginData?.isTaxPro &&
        showAppointmentsToast &&
        pastAppointments?.recentAppointment &&
        pastAppointments?.recentAppointment?.creator?.firstname &&
        pastAppointments?.recentAppointment?.users[0]?.lastname && (
          <ToastMessage
            styles={{ marginTop: "90px", minWidth: 400 }}
            onClose={() => setShowAppointmentsToast(false)}
            title={`👋 Hey ${user?.LoginData?.firstname}, Confirm Attendance`}
            message={
              <>
                {" "}
                <p>
                  You had an appointment schedule on{" "}
                  <strong>
                    {convertTimeIntoSselectedTZ(
                      pastAppointments?.recentAppointment?.timezone,
                      moment.tz.guess(),
                      moment.utc(
                        pastAppointments?.recentAppointment?.start_date
                      ),
                      "dddd, MMM D, YYYY"
                    )}
                  </strong>{" "}
                  at{" "}
                  <strong>
                    {convertTimeIntoSselectedTZ(
                      pastAppointments?.recentAppointment?.timezone,
                      moment.tz.guess(),
                      moment.utc(
                        pastAppointments?.recentAppointment.start_date
                      ),
                      "hh:mm a"
                    )}
                  </strong>{" "}
                  with{" "}
                  <strong>
                    {user.LoginData?.uuid ===
                    pastAppointments?.recentAppointment?.creator?.uuid ? (
                      <u>
                        {pastAppointments?.recentAppointment?.users[0]
                          ?.firstname +
                          " " +
                          pastAppointments?.recentAppointment?.users[0]
                            ?.lastname}
                      </u>
                    ) : (
                      <u>
                        {pastAppointments?.recentAppointment?.creator
                          ?.firstname +
                          " " +
                          pastAppointments?.recentAppointment?.creator
                            ?.lastname}
                      </u>
                    )}
                  </strong>
                </p>
                <p>Was this appointment attended ?</p>
                <p>
                  <strong
                    onClick={() => {
                      if (
                        !loading?.state &&
                        user.LoginData?.isTaxPro &&
                        !user.LoginData?.impersonation
                      ) {
                        updateHasAttandedStatus(
                          true,
                          pastAppointments?.recentAppointment?.id
                        );
                      }
                    }}
                    className={`cursor-pointer ${
                      user.LoginData?.impersonation ? "disabled-buttons" : ""
                    } `}
                  >
                    {loading?.state && loading?.answer ? (
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    ) : loading?.answer && loading?.success ? (
                      <MdDone
                        color="green"
                        style={{ height: "20px", fontSize: "16px" }}
                      />
                    ) : (
                      <u> Yes </u>
                    )}
                  </strong>{" "}
                  or{" "}
                  <strong
                    onClick={() => {
                      if (
                        !loading?.state &&
                        user.LoginData?.isTaxPro &&
                        !user.LoginData?.impersonation
                      ) {
                        updateHasAttandedStatus(
                          false,
                          pastAppointments?.recentAppointment?.id
                        );
                      }
                    }}
                    className={`cursor-pointer ${
                      user.LoginData?.impersonation ? "disabled-buttons" : ""
                    } `}
                  >
                    {loading?.state && !loading?.answer ? (
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    ) : !loading?.answer && loading?.success ? (
                      <MdDone
                        color="green"
                        style={{ height: "20px", fontSize: "16px" }}
                      />
                    ) : (
                      <u> No </u>
                    )}
                  </strong>
                  {user.LoginData?.impersonation && (
                    <p className="text-danger mt-2">Testing is disabled</p>
                  )}
                </p>
              </>
            }
            show={pastAppointments?.data?.length > 0}
            setShow={setShowToast}
          />
        )}
      {user?.LoginData?.isCustomer && (
        <Modal
          title=""
          bodyClass="p-0"
          btnText=""
          trigger="showonboardingVideoModal"
          showBtn={false}
          backdrop={false}
          size={"lg"}
          close={enableCloseWelcomeModal}
          onClose={() => {
            handleCloseOnboardingVideo();
          }}
          btnClass="closeOnboardingVideoModal"
          keyboard={false}
        >
          <div className="clearfix">
            {/* {assessmentLoading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading assessment data...</span>
                </div>
              </div>
            ) : ( */}
              <MultyStepOnboading
                setEnableCloseWelcomeModal={setEnableCloseWelcomeModal}
              />
            {/* )} */}
          </div>
        </Modal>
      )}
      <Link
        to="#"
        id="showOnboardingVideo"
        className="text-decoration-none text-dark"
        data-bs-toggle="modal"
        data-bs-target="#showonboardingVideoModal"
      ></Link>
    </div>
  );
}
